/**
 * Client-side id for a locally created record, unique enough to key a list and
 * to correlate an optimistic row with the one the backend later confirms. Not a
 * UUID and not collision-proof across clients — never persist it as an
 * identity.
 *
 * It sits in the neutral zone because the surfaces that mint these ids are not
 * all Chat's: Evidence side-by-side and Chat's own stream both build timeline
 * rows with it.
 */
export const generateId = () =>
  `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
